/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Best_MatchInputs */

const en_search_best_match = /** @type {(inputs: Search_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best match`)
};

const zh_hans1_search_best_match = /** @type {(inputs: Search_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最佳匹配`)
};

const pt_br2_search_best_match = /** @type {(inputs: Search_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhor resultado`)
};

const es_search_best_match = /** @type {(inputs: Search_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor coincidencia`)
};

const fr_search_best_match = /** @type {(inputs: Search_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleure correspondance`)
};

const de_search_best_match = /** @type {(inputs: Search_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bester Treffer`)
};

const ru_search_best_match = /** @type {(inputs: Search_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшее совпадение`)
};

const it_search_best_match = /** @type {(inputs: Search_Best_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliore corrispondenza`)
};

/**
* | output |
* | --- |
* | "Best match" |
*
* @param {Search_Best_MatchInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_best_match = /** @type {((inputs?: Search_Best_MatchInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Best_MatchInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_best_match(inputs)
	if (locale === "pt-BR") return pt_br2_search_best_match(inputs)
	if (locale === "es") return es_search_best_match(inputs)
	if (locale === "fr") return fr_search_best_match(inputs)
	if (locale === "de") return de_search_best_match(inputs)
	if (locale === "ru") return ru_search_best_match(inputs)
	if (locale === "it") return it_search_best_match(inputs)
	return en_search_best_match(inputs)
});